import Banner from '../../../components/BannerDefault';

import style from './fraseVendedora.module.scss';

const parse = require('html-react-parser');

export default function Frasevendedora({ destaque }) {
  if (!destaque) return null;

  return (
    <Banner
      image={{ src: '/img/fundofrasevendedora.webp' }}
      width='100%'
      height='fit-content'>
      <div className={style.section}>
        <span>{parse(destaque)}</span>
      </div>
    </Banner>
  );
}
